import React, { FC } from 'react';
import { Controller, Control } from 'react-hook-form';
import type { MedicalHistoryValues } from '../types/flow';
import { FormTextArea, FLabel, SectionDivider } from '../../assessment-portal/components/form-fields';

interface HealthMedicationsFormProps {
  control: Control<MedicalHistoryValues>;
}

const HEALTH_TEXTAREA_ROWS = 6;

const HealthMedicationsForm: FC<HealthMedicationsFormProps> = ({ control }) => (
  <>
    <h2 className="text-xl font-bold mb-1 text-brand-dark">Medical History — Part 3 of 4</h2>
    <p className="text-slate-500 text-sm mb-6">Health conditions, family history, and medications.</p>

    <div className="space-y-5">
      <SectionDivider>Health &amp; Medications</SectionDivider>

      <div className="adhd-mq-card">
        <FLabel isRequired>Family history of mental health diagnosis?</FLabel>
        <Controller
          name="familyHistory"
          control={control}
          render={({
            field: {
              ref, name, value, onChange, onBlur,
            },
          }) => <FormTextArea ref={ref} name={name} value={value} onChange={onChange} onBlur={onBlur} rows={HEALTH_TEXTAREA_ROWS} placeholder="e.g. Mother — depression, Brother — ADHD, None known" />}
        />
      </div>

      <div className="adhd-mq-card">
        <FLabel isRequired>Any physical health conditions affecting cognitive function?</FLabel>
        <Controller
          name="physicalConditions"
          control={control}
          render={({
            field: {
              ref, name, value, onChange, onBlur,
            },
          }) => <FormTextArea ref={ref} name={name} value={value} onChange={onChange} onBlur={onBlur} rows={HEALTH_TEXTAREA_ROWS} placeholder="e.g. thyroid issues, head injuries, sleep apnoea, None" />}
        />
      </div>

      <div className="adhd-mq-card">
        <FLabel isRequired>Current medications, including past ADHD medication trials</FLabel>
        <Controller
          name="medications"
          control={control}
          render={({
            field: {
              ref, name, value, onChange, onBlur,
            },
          }) => <FormTextArea ref={ref} name={name} value={value} onChange={onChange} onBlur={onBlur} rows={HEALTH_TEXTAREA_ROWS} placeholder="List all medications and dosages, including any previous ADHD medications tried" />}
        />
      </div>

      <div className="adhd-mq-card">
        <FLabel isRequired>Alcohol, caffeine, nicotine, or drug / substance use</FLabel>
        <Controller
          name="substances"
          control={control}
          render={({
            field: {
              ref, name, value, onChange, onBlur,
            },
          }) => <FormTextArea ref={ref} name={name} value={value} onChange={onChange} onBlur={onBlur} rows={HEALTH_TEXTAREA_ROWS} placeholder="e.g. Alcohol — social, Caffeine — 2 coffees/day, Non-smoker, No recreational drugs" />}
        />
      </div>
    </div>
  </>
);

export default HealthMedicationsForm;
